<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <v-menu
      v-if="isMobile"
      offset-x
      right
    >
      <template #activator="{ on, attrs }">
        <v-icon
          dark
          large
          color="#37474F"
          v-bind="attrs"
          v-on="on"
        >
          mdi-menu
        </v-icon>
      </template>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getOrganizationDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-text-box-multiple-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Organization Details
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getModules()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-office-building-cog-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Modules
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getPurchaseList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-credit-card-check-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Purchases
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-btn
      color="red darken-3"
      class="ml-7"
      @click="back()"
    >
      back
    </v-btn>
    <v-navigation-drawer
      v-if="!isMobile"
      permanent
      color="#ECEFF1"
      expand-on-hover
      absolute
      bottom
      floating
    >
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="nav-title-style">
              <v-list-item-icon>
                <v-icon
                  style="font-size:25px;color:#37474F;font-weight:bold;"
                >
                  mdi-domain
                </v-icon>
              </v-list-item-icon>
              Organization
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <br>
      <v-list
        nav
        dense
      >
        <v-list-item-group
          v-model="selectedItem"
          color="#37474F"
          mandatory
        >
          <v-list-item
            link
            @click="getOrganizationDetails()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-text-box-multiple-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Organization Detiails
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getModules()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-office-building-cog-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Modules
            </v-list-item-title>
          </v-list-item>
          <v-list-item
            link
            @click="getPurchaseList()"
          >
            <v-list-item-icon>
              <v-icon style="font-size:25px;color:#37474F;font-weight:bold;">
                mdi-credit-card-check-outline
              </v-icon>
            </v-list-item-icon>
            <v-list-item-title
              style="font-size:14px;color:#37474F;font-weight:bold;"
            >
              Purchases
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <organization-details v-if="showOrganizationDetails" />
    <organization-module-details v-if="showOrganizationModule" />
    <organization-purchase-list v-if="showOrganizationPurchaseList" />
  </v-container>
</template>
<script>
  import OrganizationModuleDetails from 'src/views/dashboard/organizations/OrganizationModuleDetails.vue';
  import OrganizationDetails from 'src/views/dashboard/organizations/OrganizationDetails.vue';
  import OrganizationPurchaseList from 'src/views/dashboard/organizations/OrganizationPurchaseList.vue';

  export default {
    name: 'OrganizationDetailsLandingPage',
    components: {
      'organization-module-details': OrganizationModuleDetails,
      'organization-details': OrganizationDetails,
      'organization-purchase-list': OrganizationPurchaseList,
    },
    data: () => ({
      selectedItem: -1,
      showOrganizationDetails: true,
      showOrganizationModule: false,
      showOrganizationPurchaseList: false,
    }),
    computed: {
      isMobile () {
        if (this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
          return false;
        } else {
          return true;
        }
      },
    },
    mounted () {
      this.selectedItem = 0;
    },
    methods: {
      getOrganizationDetails () {
        this.showOrganizationDetails = true;
        this.showOrganizationModule = false;
        this.showOrganizationPurchaseList = false;
      },
      back () {
        this.$router.push({ name: 'Organizations' });
      },
      getModules () {
        this.showOrganizationModule = true;
        this.showOrganizationDetails = false;
        this.showOrganizationPurchaseList = false;
      },
      getPurchaseList () {
        this.showOrganizationPurchaseList = true;
        this.showOrganizationModule = false;
        this.showOrganizationDetails = false;
      },
    },
  };
</script>
<style scoped>
.nav-title-style {
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  color: #37474F;
  font-size: 25px;
}
</style>
